import { defineComponent as _defineComponent } from 'vue'
import { useAccountStore } from '@/store';

export default /*@__PURE__*/_defineComponent({
  __name: 'Logout',
  setup(__props) {

const accountStore = useAccountStore();
accountStore.logout();

return () => {}
}

})